module.exports = __webpack_public_path__ + "static/livro-indefinido-883d28df5d3500354c93ad7cc0d730ee.png";